
import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
    state: () => {
        return {
            access_token: '',
            nickname: '',
            scene: '',
            qrcodeUrl: '',
            imgurl: '',
            id: '',

        }
    },
    actions: {
        getInfo() {
            this.access_token = localStorage.getItem('access_token')
            this.nickname = localStorage.getItem('nickname')
            this.id = localStorage.getItem('id')
            this.imgurl = localStorage.getItem('imgurl')
        },
        setInfo(access_token, nickname, id, imgurl) {
            localStorage.setItem('access_token', access_token)
            localStorage.setItem('nickname', nickname)
            localStorage.setItem('id', id)
            localStorage.setItem('imgurl', imgurl)
            this.access_token = access_token
            this.nickname = nickname
            this.id = id
            this.imgurl = imgurl
        },


        removeInfo() {
            localStorage.removeItem('access_token')
            localStorage.removeItem('nickname')
            localStorage.removeItem('id')
            localStorage.removeItem('imgurl')


            this.access_token = ''
            this.nickname = ''
            this.scene = ''

            this.id = ''
            this.imgurl = ''
        },
    }
})

